import {Message} from 'element-ui'
import router from '@/router';

export default {
  /*
 * to handle http exception for component request(which doesn't call axios)
 * eg: el-upload
 */
  handleExceptionForComponentRequest: (response) => {
    if (response.status === 401) {
      if (response.message.includes('session timeout')) {
        Message.error(`session timeout`);
      } else {
        let temp = response.message.substring(response.message.indexOf('errorMessage') + 15);
        Message.error(temp.substring(0, temp.indexOf('","')));
      }
      router.push({name: 'Login'});
    } else {
      Message.error(`Server ${response}`);
      router.push({name: 'ErrorPage'});
    }
  },

  formatDate: (date) => {
    let tz = new Date().getTimezoneOffset();
    let time = new Date(new Date(date.substring(0, date.lastIndexOf('.')).replace('T', ' ').replace(/-/g, '/')).getTime());
    let newDate = new Date((time / 1000 + (tz / -60) * 60 * 60) * 1000);
    let year = newDate.getFullYear();
    let month = newDate.getMonth() + 1;
    let day = newDate.getDate();
    let hour = newDate.getHours();
    let min = newDate.getMinutes();
    let second = newDate.getSeconds();
    if (month < 10) {
      month = '0' + month;
    }
    if (second < 10) {
      second = '0' + second;
    }
    if (hour < 10) {
      hour = '0' + hour;
    }
    if (min < 10) {
      min = '0' + min;
    }
    if (day < 10) {
      day = '0' + day;
    }
    return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + second;
  }
};



// WEBPACK FOOTER //
// ./src/utils/commonHelper.js